"use strict";

import angular from "angular";

import template from "./list-group-collapse.component.html";
import "./list-group-collapse.component.scss";

class ListGroupCollapseComponent {
    openeds = [0];

    constructor() {}

    $onInit() {}

    onToggleGroup(index) {
        const hasIndex = this.openeds.indexOf(index);
        if (hasIndex > -1) {
            this.openeds.splice(hasIndex, 1);
        } else {
            this.openeds.push(index);
        }
    }

    isOpened(index) {
        return this.openeds.includes(index);
    }

    onCheckItem(item) {
        if (this.handleCheckItem) this.handleCheckItem({ item: item });
    }
}

export { ListGroupCollapseComponent };

ListGroupCollapseComponent.$inject = [];

const component = {
    bindings: {
        groups: "=",
        hideChevron: "<",
        openeds: "<",
        badge: "<",
        handleCheckItem: "&"
    },
    controller: ListGroupCollapseComponent
};

const name = "listGroupCollapseComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
